import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withRouter } from "react-router";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

class MerchantsTable extends Component {
  viewFormatter = (cell, row) => {
    const { id } = row;
    const pathname = `/merchants/${id}`;

    return (
      <Link
        to={{
          pathname,
          state: { data: row, previousLocation: { ...this.props.location } },
        }}>
        <div>
          <i
            className="fa fa-search"
            style={{ color: "#D15050" }}
            data-cy="view-tx"
          />
        </div>
      </Link>
    );
  };

  render() {
    return (
      <BootstrapTable
        data={this.props.data}
        options={this.props.options}
        fetchInfo={this.props.fetchInfo}
        headerStyle={headerStyle}
        version="4"
        search={this.props.search}
        pagination
        striped
        hover
        condensed
        remote>
        <TableHeaderColumn
          dataFormat={this.viewFormatter}
          dataField="id"
          width="60"
          dataAlign="center"
          isKey>
          View
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name" width="200">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="type" width="200">
          Type
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="address" width="200">
          Address
        </TableHeaderColumn>
      </BootstrapTable>
    );
  }
}

MerchantsTable.defaultProps = {
  search: true,
};

MerchantsTable.propTypes = {
  data: PropTypes.array,
  options: PropTypes.object,
  fetchInfo: PropTypes.object,
  search: PropTypes.bool,
  location: PropTypes.object.isRequired,
};

export default withRouter(MerchantsTable);
